import { apiSlice } from "../../app/api/apiSlice";

export const generalApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    connectSQL: builder.mutation({
      query: (formData) => ({
        url: "/connectpg",
        method: "POST",
        body: formData,
      }),
    }),
    getSearchDataSources: builder.query({
      query: ({ value }) => ({
        url: "/search/datasources",
        params: {
          query: value,
        },
      }),
    }),
    createSheet: builder.mutation({
      query: (requiredCreateSheetState) => ({
        url: "workbookapi/createSheet&workbook",
        method: "POST",
        body: { ...requiredCreateSheetState },
      }),
    }),
  }),
});

export const {
  useConnectSQLMutation,
  useGetSearchDataSourcesQuery,
  useCreateSheetMutation,
} = generalApiSlice;
